<template>
	<div class="errorBox" style="height:452px;">
        <div class="errorText">
             <img src="../../assets/images/common/tomoon_icon.png">
             <div>
                 您来到了月球，请返回…
             </div>
             <span @click="goback()">返回</span>
        </div>  
	</div>
</template>

<script>
	export default{
       data(){
           return{}
       },
       methods:{
           goback(){
               this.$router.back(-1)
           }
       }
	}
</script>

<style lang="scss">
	
	.errorBox{
        	height: 402px;
		width: 1200px;
		height: 100%;
		background-color:#fff;
        margin:  20px auto;
        position: relative;
        .errorText{
            width:160px;
            height:300px;
            position: absolute;
            left: 50%;
            margin-left: -80px;
            top:50%;
            margin-top: -150px;
            text-align: center;
            padding-top:30px;
            div{
                width:160px;
font-size:14px;
color: #969696;
            }
            img{
                display: block;
                width: 100px;
                margin: 0 auto;
                margin-bottom: 20px;

            }
            span{
                width:120px;
height:38px;
color: #787878;
background:rgba(255,255,255,1);
border-radius:20px;
border:1px solid rgba(120,120,120,1);
display: inline-block;
margin: 20px auto;
text-align: center;
line-height: 36px;
cursor: pointer;
            }
            span:hover{
                background: #216CFF;
                color: #fff;
                border-color: #216CFF;
            }
        }
	}

	
</style>
